import { Component, Input, OnInit } from '@angular/core';
import { Select } from '@ngxs/store';
import { Observable, Subscription } from 'rxjs';
import { TypeElementStockDto } from 'src/api/models';
import { ControlPanelStore } from 'src/states/control-panel.store';

@Component({
  selector: 'app-type-element-stock',
  templateUrl: './type-element-stock.component.html',
  styleUrls: ['./type-element-stock.component.css']
})
export class TypeElementStockComponent implements OnInit {

  @Select(ControlPanelStore.typesElementsStock$) typesElementsStock$: Observable<TypeElementStockDto[]>;

  @Input() public typeElementStockId: number;

  TypeElementStockInComponent: TypeElementStockDto;

  s: Subscription;

  constructor() { }

  ngOnInit(): void {
    this.s = this.typesElementsStock$.subscribe(res => {
      if (res != null) {
        let tes = res.filter(p => p.Id == this.typeElementStockId);
        this.TypeElementStockInComponent = tes.length == 1 ? tes[0] : { Nom: null };
      }
    });
  }

  ngOnDestroy() {
    this.s?.unsubscribe();
  }
}

